import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { GetPermissionGroupsList } from "../Responses/GetPermissionGroupsList";

export async function getPermissionGroupsList(data) {
	let response = await getAPIResponse("/v1/permission-group-list", data);
	if (response === null) {
		return null;
	}
	let getPermissionGroupsList = GetPermissionGroupsList.createFromResponseData(response);
	return getPermissionGroupsList;
}